module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('c-view', [_c('c-page', [(_vm.nav_type) ? _c('c-navbar') : _vm._e(), _vm._v(" "), _c('c-content', {
    staticClass: "page_content"
  }, [_c('div', {
    staticClass: "group bg_img1"
  }), _vm._v(" "), _c('div', {
    staticClass: "group bg_img2"
  }), _vm._v(" "), _c('div', {
    staticClass: "group bg_img3"
  }), _vm._v(" "), _c('div', {
    staticClass: "group bg_img4"
  }), _vm._v(" "), _c('div', {
    staticClass: "group bg_img5"
  }), _vm._v(" "), _c('div', {
    staticClass: "group bg_img6"
  })]), _vm._v(" "), _c('div', {
    staticClass: "bottom_btn"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.gotonewdealer
    }
  }, [_vm._v("成为代理商")])])], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-right",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-60dc197c","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/dealer/index.vue
// module id = 1055
// module chunks = 2